<script>
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
import cloneDeep from 'lodash/cloneDeep'

export default {
  page: {
    title: '編輯會員等級',
    meta: [{ name: 'add-memberlevel', content: 'Edit MemberLevel' }],
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  provide() {
    return {
      isEdit: true,
    }
  },
  data() {
    return {
      activeTab: '0',
      tabList: Object.freeze([
        {
          title: '方案設定',
          component: () => import('./MemberLevelSettingStep1'),
        },
        {
          title: '折扣設定',
          component: () => import('./MemberLevelSettingStep2Feature'),
        },
      ]),
      submitData: cloneDeep(this.defaultValue),
      tryingToSave: false,
      tryingToRemove: false,
      eachDiscount: {
        deposit: [],
        prepaid: [],
        'service-add': [],
        service: [],
        good: [],
      },
      continueSavePar: true, // 是否可以繼續儲存的判斷
      btnDisabled: false,
      hintDialogVisible: false,
    }
  },
  computed: {
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    },
    isConditionsDuplicate() {
      const typeDuplicate = new Set()
      const depositDuplicate = new Set()

      for (const condition of this.submitData.upgradeCondition) {
        if (condition.type === 'deposit-plan') {
          // 檢查 deposit-plan 的 value 是否重複
          if (depositDuplicate.has(condition.value)) {
            return true
          }
          depositDuplicate.add(condition.value)
        } else {
          // 檢查其他 type 是否重複
          if (typeDuplicate.has(condition.type)) {
            return true
          }
          typeDuplicate.add(condition.type)
        }
      }
      return false
    },
  },
  created() {},
  methods: {
    /***
     * @description 儲存變更
     */
    async onClickSave(type) {
      if (this.isConditionsDuplicate) {
        this.$message.error('會員升級條件重複')
        return
      }
      await this.validate()
      if (!this.continueSavePar) return
      this.composeUpdateDiscount()
      this.hintDialogVisible = true
      this.tryingToSave = true

      await this.$store
        .dispatch('memberLevel/store', this.submitData)
        .then(() => {
          messageStore('edit')
        })
        .finally(() => {
          this.tryingToSave = false
        })
    },
    backToMemberPage() {
      this.$router.push({
        name: 'member',
        params: {
          activeTab: '1',
          pagination: this.pagination,
          filterData: this.filterData,
        },
      })
    },
    composeUpdateDiscount() {
      try {
        const updateItem = (data, type, idAlias) => {
          data.forEach((item) => {
            const index = this.submitData[type].findIndex((dbItem) => dbItem[idAlias] === item[idAlias])
            if (index > -1) {
              this.submitData[type][index]['discount'] = item['discount']
              this.submitData[type][index]['discountType'] = item['discountType']
            } else {
              this.submitData[type].push(item)
            }
          })
        }

        if (this.eachDiscount['service']) {
          updateItem(this.eachDiscount['service'], 'services', 'id')
        }
        if (this.eachDiscount['service-add']) {
          updateItem(this.eachDiscount['service-add'], 'services', 'id')
        }
        if (this.eachDiscount['prepaid']) {
          updateItem(this.eachDiscount['prepaid'], 'prepaids', 'groupAlias')
        }
        if (this.eachDiscount['deposit']) {
          updateItem(this.eachDiscount['deposit'], 'deposits', 'id')
        }
        if (this.eachDiscount['good']) {
          updateItem(this.eachDiscount['good'], 'services', 'id')
        }
        console.log('this.submitData', this.submitData)
      } catch (error) {
        console.error(error.message)
      }
    },
    async tryToRemove() {
      try {
        await messageBoxDelete('該等級方案')
        try {
          this.tryingToRemove = true
          const data = {
            ...this.submitData,
            state: -1,
          }
          await this.$store
            .dispatch('memberLevel/updateState', {
              ids: [this.submitData.id],
              state: -1,
            })
            .then(() => {
              messageDelete()
              this.$router.push({
                name: 'member',
                params: {
                  activeTab: '1',
                  pagination: this.pagination,
                  filterData: this.filterData,
                },
              })
            })
            .finally(() => {
              this.tryingToRemove = false
            })
        } finally {
        }
      } catch {}
    },
    async validate(step) {
      try {
        const currentTab = `step${this.activeTab}`
        if (this.$refs[currentTab].$refs.form) {
          await this.$refs[currentTab].$refs.form.validate()
        } else {
          return true
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    async beforeTabSwitch(activeName, oldActiveName) {
      try {
        return this.validate()
      } catch (error) {
        console.error(error.message)
      }
    },
    cancel() {
      this.$router.push({
        name: 'member',
        params: {
          activeTab: '1',
          pagination: this.pagination,
          filterData: this.filterData,
        },
      })
    },
    handleClick(tab, event) {},
    /**
     * @description 更新submitData內的discount資料
     */
    updateSubmitData(data) {
      try {
        if (data.submitData.length > 0 && data.submitData[0]) {
          this.eachDiscount[data.type] = data.submitData.filter((item) => {
            if (typeof item.discount === 'string') {
              return
            }
            if (item.discount < 0) {
              return
            }
            if (item.discount > 100 && item.discountType === '%') {
              return
            }
            return item
          })
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    continueSave(nvl) {
      this.continueSavePar = nvl
    },
    updateCondition(conditions) {
      const conditionData = []

      if (conditions.length === 1 && (!conditions[0].type || !conditions[0].value)) {
        this.submitData.upgradeCondition = conditionData
        return
      }

      conditions.forEach((item) => {
        const { logic, condition, value } = item
        const data = {
          logic,
          type: condition,
          value,
        }
        conditionData.push(data)
      })
      this.submitData.upgradeCondition = conditionData
    },
    saveStatus(status) {
      this.btnDisabled = status
    },
  },
}
</script>
<template>
  <div :class="$style.page">
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase" :before-leave="beforeTabSwitch" @tab-click="handleClick">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`"></el-tab-pane>
    </el-tabs>
    <div :class="$style.pageContent">
      <component
        :is="tabList[activeTab].component"
        :ref="`step${activeTab}`"
        :default-value.sync="submitData"
        @updateSubmitData="updateSubmitData"
        @saveStatus="saveStatus"
        @continueSave="continueSave"
        @updateCondition="updateCondition"
      />
    </div>
    <div :class="$style.footer">
      <el-button v-if="!defaultValue.default" class="is-round" type="danger" :loading="tryingToRemove" :disabled="tryingToRemove || !!defaultValue.default" @click="tryToRemove">刪除</el-button>
      <el-button class="is-round" :loading="tryingToSave" @click="cancel">取消</el-button>
      <el-button class="is-round" type="primary" :loading="tryingToSave" :disabled="!btnDisabled" @click="onClickSave">儲存變更</el-button>
    </div>
    <el-dialog title="提醒" :visible.sync="hintDialogVisible" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" top="0" width="30%">
      <div class="d-flex justify-content-center">
        <span>稍等一下，資料約在五分鐘後儲存完成</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="is-round" @click="backToMemberPage">我已了解</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
